import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';

/** Small solid button next to a status pill: the one thing to do for that status */
export function RowActionButton({ onClick, children }: { onClick: () => void; children: ReactNode }) {
  return (
    <Button size="sm" className="h-7 px-2.5 text-xs hover:scale-100" onClick={onClick}>
      {children}
    </Button>
  );
}
